import { graphBackFill, graphDefault, graphOutlinesUnfilled } from './';
export const graphNodeGroupOpen = (theme, parameters) => {
  const outlinesUnfilled = graphOutlinesUnfilled(theme, parameters);
  const defaultPattern = graphDefault(theme, parameters);
  const common = {
    fillColor: graphBackFill(theme, parameters).fillColor,
    transparency: 0,
    lineThickness: outlinesUnfilled.lineThickness
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          lineColor: defaultPattern.n3,
          textColor: defaultPattern.n3
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          lineColor: outlinesUnfilled.lineColor,
          textColor: outlinesUnfilled.lineColor
        };
      }
    default:
      {
        return {
          ...common,
          lineColor: defaultPattern.n_2,
          textColor: defaultPattern.n_2
        };
      }
  }
};
//# sourceMappingURL=graphNodeGroupOpen.js.map